import { tv } from "@fanka/tailwind-variants";
import clsx from "clsx";

export const EXPAND_DRAWER_MIN_WIDTH = 586;
export const EXPAND_DRAWER_MAX_WIDTH = 1171;
export const EXPAND_DRAWER_HEADER_HEIGHT = 40;
export const EXPAND_DRAWER_FOOTER_HEIGHT = 76;

export const EXPAND_DRAWER_CONTENT_CLASS_NAME = tv({
  base: clsx(
    "z-drawer fixed right-0 top-0 h-screen bg-grayScale-100 overflow-hidden",
    "shadow-[-4px_4px_14px_0_rgba(0,0,0,0.15)] rounded-[8px_0_0_8px]",
  ),
  variants: {
    isOpen: {
      true: "animate-[slideInRight_200ms_ease-in-out]",
      false: "animate-[slideOutRight_200ms_ease-in-out]",
    },
  },
  defaultVariants: {
    isOpen: false,
  },
});
